module.exports = __webpack_public_path__ + "img/title+@2x.9b57be68.png";